import * as React from "react";
import { Divider } from "../..";
import {
    MarketResearchCompensation,
    MarketResearchDiversity,
    MarketResearchProvider,
    MarketResearchSection,
    MarketResearchState,
    MarketResearchSummary,
    MarketResearchSupplyDemand,
    MarketResearchType,
} from "..";

interface MarketResearchToolProps {
    state: MarketResearchState;
    marketResearchType: MarketResearchType;
    helpSection?: React.ReactNode;
}

export const MarketResearchTool = (props: MarketResearchToolProps) => {
    const { state, helpSection, marketResearchType } = props;

    return (
        <MarketResearchProvider state={state}>
            <MarketResearchSummary
                marketResearchType={marketResearchType}
                isJobInsights={false}
            />

            <Divider gutterBottom gutterTop />
            <MarketResearchSection title="salary" id="compensationSection">
                <MarketResearchCompensation />
            </MarketResearchSection>

            <Divider gutterBottom gutterTop />
            <MarketResearchSection
                title="supply & demand"
                id="supplyDemandSection"
            >
                <MarketResearchSupplyDemand />
            </MarketResearchSection>

            <Divider gutterBottom gutterTop />
            <MarketResearchSection title="diversity" id="diversitySection">
                <MarketResearchDiversity />
            </MarketResearchSection>

            {!!helpSection ? (
                <>
                    <Divider gutterBottom gutterTop />
                    {helpSection}
                </>
            ) : null}
        </MarketResearchProvider>
    );
};
